/**
 * Kill / revive story
 * @author Ryan Gladstone
 * <story-kill-revive story="story"></story-kill-revive>
 */

import template from './storyKillRevive.html';

function storyKillRevive() {
  return {
    template,
    restrict: 'E',
    scope: {
      story: '='
    },
    controller: 'StoryKillReviveController'
  };
}

function StoryKillReviveController($scope) {
  $scope.kill = () => {
    $scope.story.killStory().then(() => {});
  };

  $scope.revive = () => {
    $scope.story.reviveStory().then(() => {});
  };
}

const storyKillCtrlArray = ['$scope', StoryKillReviveController];

export default function (ngModule) {
  ngModule.directive('storyKillRevive', storyKillRevive);
  ngModule.controller('StoryKillReviveController', storyKillCtrlArray);
}
